import { TaskPhotosEntity } from "tm-shared/types";

export const getPhotoIdsFromPhotoTask = <T extends TaskPhotosEntity>(
    items: Record<string, T>,
) => {
    return Object.values(items)
        .map((item) => item?.photos)
        .flat()
        .filter(Boolean);
};
